import { styled } from '@mui/material';

import { useParams } from 'react-router';

import { useI18n } from '@app-velocity/i18n';
import { StopIcon } from '@app-velocity/icons';

import { useUserSimulationControl } from '../../../hooks/useUserSimulationControl';
import { useScenarioDetailsContext } from '../../../hooks/useScenarioDetailsContext';
import { useSimulationContext } from '../../../hooks/useSimulationContext';

const StopButton = styled('button')(({ theme }) => ({
  background: 'transparent',
  border: 'none',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  cursor: 'pointer',
  borderRadius: theme.spacing(1),
  color: 'var(--info-info-icon-primary-color)',
  padding: `${theme.spacing(1.5)} ${theme.spacing(2.5)}`,
  '&:disabled': {
    opacity: 0.5,
  },
  '&:hover': {
    textDecoration: 'underline',
  },
}));

const StopButtonContainer = styled('div')({
  display: 'flex',
  ailgnItems: 'center',
  height: '100%',
  flex: 1,
});

export const Stop = () => {
  const { t } = useI18n();
  const { mode, review } = useSimulationContext();
  const { stop } = useUserSimulationControl(mode);
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const { scenario } = useScenarioDetailsContext();

  const handleStop = () => {
    if (!scenario || !workspaceId || !review) return;
    stop(workspaceId, scenario.id!, scenario.shareToken!, review.reviewId!);
  };

  return (
    <StopButtonContainer>
      <StopButton onClick={handleStop}>
        {t('prototypes:stop_simulation')} <StopIcon />
      </StopButton>
    </StopButtonContainer>
  );
};
